var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapContainer",attrs:{"id":"mapContainer"}},[_c('div',{staticClass:"map",attrs:{"id":"newCooperativeMap"}})])
}]

export { render, staticRenderFns }